var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-sheet-box"},[_c('button',{on:{"click":function($event){return _vm.beginSheethandle()}}},[_vm._v("开始测试")])])}
var staticRenderFns = []

export { render, staticRenderFns }